import React, { useState, useContext, useEffect } from 'react';
import { Table, Row, Col, Button, Tag, Drawer, Dropdown, Menu } from 'antd';
import { Dinheiro } from "../Numeros/dinheiro";
import moment from 'moment';
import './lista-pedidos.scss';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import { usePedido } from '../../services/usePedidos';
import { ambienteContext } from '../../context'
import { ImpressaoPedido } from '../formulario-pedido/ImpressaoPedido';
import { ImpressaoRomaneio } from '../formulario-pedido/ImpressaoRomaneio';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faPrint, faFileAlt } from '@fortawesome/pro-duotone-svg-icons';
import NumberFormat from 'react-number-format';


const PopupImpressao = (props) => {

    const { pedido, visible, onCloseHandle, setImprimindo, tipoImpressao = 'pedido' } = props;

    const [printing, setPrinting] = useState(false);

    useEffect(() => {
        if (pedido && pedido != null && pedido.id && visible) {
            print();
        }
    }, [visible, tipoImpressao]);

    const getWidth = () => {
        const w = window.innerWidth;
        const w10 = w * 0.1;
        return w - w10

    }

    const print = async () => {



        // setPrinting(true);
        // const opts = {
        //     pagebreak: { mode: 'avoid-all'},
        //     fileName: "pedido-"+ pedido.numeroPedido + ".pdf",
        //     margin: [7, 2,7,2],
        //     jsPDF: { unit: 'mm' }

        // }
        // if(window.innerWidth < 768){

        //     window.scrollTo(0,0);

        //     const elm = document.querySelector("#impressaoPedido");
        //     const worker = html2Pdf.Worker().from(elm);

        //     worker.set(opts);
        //     const pdfUrl = await worker.output('dataurlstring',{fileName: "pedido-"+ pedido.numeroPedido + ".pdf"});
        //     setPrinting(false);
        //     setImprimindo(false)
        //     window.open(pdfUrl, '_blank')
        //     // setTimeout(async ()=>{
        //     // }, 100)

        // } else {

        //     //setMostraImpressao(true);

        //     const elm = document.querySelector("#impressaoPedido");
        //     const iframe = document.querySelector("#impressao");
        //     const worker = html2Pdf.Worker().from(elm);

        //     worker.set(opts)
        //     const pdfUrl = await worker.outputPdf('dataurlstring',{});
        //     iframe.setAttribute('src', pdfUrl);

        //     setPrinting(false);
        //     setImprimindo(false)
        //     // setTimeout(async ()=>{
        //     // }, 100)
        // }
    };

    const drawer = () => {
        if (window.innerWidth >= 768) {
            return (
                <div>


                    <Drawer visible={visible && !printing} width={getWidth()} closable={true} onClose={() => onCloseHandle()} footer={
                        <Button type="primary" onClick={() => onCloseHandle()}>Fechar</Button>
                    }>
                        <iframe id="impressao" name="impressao" style={{ width: "calc(100% - 30px)", height: "calc(100% - 0px)" }}></iframe>
                    </Drawer>

                </div>);
        }
        return <></>;


    }

    return (
        <>
            {tipoImpressao === 'romaneio' ?
                <ImpressaoRomaneio pedido={pedido}></ImpressaoRomaneio> :
                <ImpressaoPedido pedido={pedido}></ImpressaoPedido>
            }
            {drawer()}
        </>
    );
}

const StatusPedido = ({ status, statusMap }) => {
    const stat = statusMap[status];
    if (stat) {
        return (<Tag color={stat.cor} >{stat.descricao.toLowerCase()}</Tag>)
    } else {
        return <></>;
    }
}

const Toolbar = ({ setImprimindo, imprimindo = false, onExcluir = () => { }, selectedRowKeys, buscaPedidos, definePedidoImprimir, values, tipoPedido, dadosPedidosEncontrados, setTipoImpressao }) => {

    const ambiente = useContext(ambienteContext);
    const { separarEstoque, voltarEstoque, emitirNFe, removerPedidos, buscaPedido } = usePedido();
    const [separandoEstoque, setSeparandoEstoque] = useState(false);
    const [voltandoEstoque, setVoltandoEstoque] = useState(false);
    const [emitindoNFe, setEmitindoNFe] = useState(false);
    const [removendo, setRemovendo] = useState(false);
    // const [imprimindo, setImprimindo] = useState(false);

    const voltarEstoqueClickHandle = async () => {
        setVoltandoEstoque(true);
        try {
            const pedidos = values.filter(value => value.id == selectedRowKeys[0])
            const pedido = pedidos[0];
            await voltarEstoque(pedido);
            buscaPedidos();

        } catch (e) {

        } finally {
            setVoltandoEstoque(false);
        }
    }

    const separarEstoqueClickHandle = async () => {
        setSeparandoEstoque(true);
        try {
            const pedidos = values.filter(value => value.id == selectedRowKeys[0])
            const pedido = pedidos[0];
            await separarEstoque(pedido);
            buscaPedidos();

        } catch (e) {
            console.log(e)
        } finally {
            setSeparandoEstoque(false);
        }
    }

    const emitirNFeHandle = async () => {
        try {
            setEmitindoNFe(true)
            const pedidos = values.filter(value => value.id == selectedRowKeys[0])
            const pedido = pedidos[0];
            const nfe = await emitirNFe(pedido);
            setTimeout(() => {
                window.location = ambiente.links["emitir-nfe"].replace(":id", nfe.idNFe);
            }, 50)
        } catch (e) {
            console.log(e);
        } finally {
            setEmitindoNFe(false)
        }
    }

    values = values.map(value => {
        value.key = value.id;
        return value;
    })

    const deveDesabilitarVoltaEstoque = () => {
        if (selectedRowKeys.length != 1) {
            return true;
        }

        const pedidos = values.filter(value => value.id == selectedRowKeys[0])
        if (pedidos.length) {
            const pedido = pedidos[0];

            return (pedido.estoque != "SEPARADO") || (pedido.status == "EXCLUIDO");
        } else {
            return true;
        }
    }

    const deveDesabilitarRemover = () => {
        console.log(selectedRowKeys);
        if (selectedRowKeys.length == 0) {
            return true;
        }

        const pedidos = values.filter((value) => (selectedRowKeys.indexOf(value.id) >= 0))
        console.log(pedidos);
        let retorno = false;
        for (let i = 0; i < pedidos.length; i++) {
            const pedido = pedidos[i];
            retorno = retorno || (pedido.estoque == "SEPARADO") || (pedido.status == "EXCLUIDO");
        }
        console.log(retorno);
        return retorno;

    }

    const deveDesabilitarRomaneio = () => {
        if (selectedRowKeys.length != 1) {
            return true;
        }
        const pedidos = values.filter(value => value.id == selectedRowKeys[0])
        if (pedidos.length) {
            const pedido = pedidos[0];
            // Romaneio deve estar disponível apenas para pedidos que não estejam excluídos
            // A validação de itens será feita quando o pedido for carregado completamente
            return (pedido.status == "EXCLUIDO");
        }
        return true;
    }

    const deveDesabilitarSepararEstoque = () => {
        if (selectedRowKeys.length != 1) {
            return true;
        }
        const pedidos = values.filter(value => value.id == selectedRowKeys[0])
        if (pedidos.length) {
            const pedido = pedidos[0];
            return (pedido.estoque == "SEPARADO") || (pedido.status == "EXCLUIDO");
        }
        return true;
    }

    const deveDesabilitarEditar = () => {
        if (selectedRowKeys.length != 1) {
            return true;
        }

        const pedidos = values.filter(value => value.id == selectedRowKeys[0])
        if (pedidos.length) {
            const pedido = pedidos[0];
            return (pedido.status == "EXCLUIDO");
        } return true;
    }

    const deveDesabilitarEmitirNFe = () => {
        if (selectedRowKeys.length != 1) {
            return true;
        }
        const pedidos = values.filter(value => value.id == selectedRowKeys[0])
        if (pedidos.length) {
            const pedido = pedidos[0];
            return (pedido.estoque != "SEPARADO") || (pedido.status == "EXCLUIDO");
        } return true;
    }

    const removerHandleClick = async () => {
        setRemovendo(true);
        try {
            await removerPedidos(selectedRowKeys);
            onExcluir();
            buscaPedidos();
        } catch (e) {
            console.log(e)
        } finally {
            setRemovendo(false)
        }
    }


    // useEffect(() => {

    //     pedidoImprimir.onReady = async () => {

    //         const copyStyles = async (src, dest) => {
    //             const styleSheetsArr = Array.from(src.styleSheets);
    //             for (const styleSheet of styleSheetsArr) {

    //                 if (styleSheet.href) {
    //                     const rules = styleSheet.cssRules;
    //                     let text = "";
    //                     for (const rule of rules) {
    //                         text += rule.cssText + "\n";
    //                     }

    //                     const styleElm = dest.createElement("style");
    //                     styleElm.innerHTML = text;
    //                     dest.head.appendChild(styleElm)
    //                 } else {
    //                     dest.head.appendChild(styleSheet.ownerNode.cloneNode(true))
    //                 }

    //             }
    //             Array.from(src.fonts).forEach(font => dest.fonts.add(font))
    //         }

    //         const printElement = document.getElementById("print");
    //         if (!printElement) {
    //             console.error("Elemento #print não encontrado");
    //             setImprimindo(false);
    //             return;
    //         }

    //         const winPrint = window.open("", "Impressao", "width=1000,height=600");
    //         winPrint.document.body.appendChild(printElement.cloneNode(true));

    //         await copyStyles(window.document, winPrint.document);

    //         winPrint.focus()
    //         winPrint.print()
    //         winPrint.close()
    //         setImprimindo(false);

    //     }
    // }, [pedidoImprimir])

    const imprimirHandleClick = async (tipoImpressao = 'pedido') => {
        setImprimindo(true);
        setTipoImpressao(tipoImpressao);
        await definePedidoImprimir(selectedRowKeys[0]);

        const copyStyles = async (src, dest) => {
            const styleSheetsArr = Array.from(src.styleSheets);
            for (const styleSheet of styleSheetsArr) {

                if (styleSheet.href) {
                    const rules = styleSheet.cssRules;
                    let text = "";
                    for (const rule of rules) {
                        text += rule.cssText + "\n";
                    }

                    const styleElm = dest.createElement("style");
                    styleElm.innerHTML = text;
                    dest.head.appendChild(styleElm)
                } else {
                    dest.head.appendChild(styleSheet.ownerNode.cloneNode(true))
                }

            }
            Array.from(src.fonts).forEach(font => dest.fonts.add(font))
        }

        const printElement = document.getElementById("print");
        if (!printElement) {
            console.error("Elemento #print não encontrado");
            setImprimindo(false);
            return;
        }

        const winPrint = window.open("", "Impressao", "width=1000,height=600");
        winPrint.document.body.appendChild(printElement.cloneNode(true));

        await copyStyles(window.document, winPrint.document);

        winPrint.focus()
        winPrint.print()
        winPrint.close()
        setImprimindo(false);
        // pedidoImprimir.onReady();

        // setPedidoImprimir({ onReady: onReadyToPrint });

        // const pedido = await buscaPedido(selectedRowKeys);
        // setPedidoImprimir({ ...pedido, onReady: onReadyToPrint });
    }

    let baseEditarUrl = '/pedido/';
    if (tipoPedido == "ORDEM_SERVICO") {
        baseEditarUrl = "/os/editar/";
    }

    if (window.innerWidth < 768) {
        const menuImpressao = (
            <Menu>
                <Menu.Item
                    onClick={() => imprimirHandleClick('pedido')}
                    disabled={selectedRowKeys.length != 1}
                >
                    <FontAwesomeIcon icon={faPrint} /> Imprimir Pedido
                </Menu.Item>
                <Menu.Item
                    onClick={() => imprimirHandleClick('romaneio')}
                    disabled={deveDesabilitarRomaneio()}
                >
                    <FontAwesomeIcon icon={faFileAlt} /> Imprimir Romaneio
                </Menu.Item>
            </Menu>
        );

        return (<>
            <Row className="toolbox" justify="end" gutter={6}>
                <Col>
                    <Dropdown overlay={
                        <Menu>
                            <Menu.Item disabled={deveDesabilitarEditar()}> <Link to={baseEditarUrl + selectedRowKeys[0]}>Editar</Link> </Menu.Item>
                            <Menu.SubMenu title="Imprimir" disabled={selectedRowKeys.length != 1}>
                                <Menu.Item
                                    onClick={() => imprimirHandleClick('pedido')}
                                    disabled={selectedRowKeys.length != 1}
                                >
                                    <FontAwesomeIcon icon={faPrint} /> Pedido Completo
                                </Menu.Item>
                                <Menu.Item
                                    onClick={() => imprimirHandleClick('romaneio')}
                                    disabled={deveDesabilitarRomaneio()}
                                >
                                    <FontAwesomeIcon icon={faFileAlt} /> Romaneio
                                </Menu.Item>
                            </Menu.SubMenu>
                            <Menu.Item onClick={removerHandleClick} disabled={deveDesabilitarRemover()}>Remover</Menu.Item>
                        </Menu>
                    } >
                        <Button size="large">Ações&nbsp;<FontAwesomeIcon icon={faChevronDown}></FontAwesomeIcon></Button>
                    </Dropdown>
                </Col>
            </Row>
            <Row className={["toolbox"]} >
                <Col className="totalizador" span={12}>
                    <span className="label">Quantidade:</span>
                    <span className="value">
                        <NumberFormat defaultValue={0} displayType={'text'} value={dadosPedidosEncontrados.quantidadePedidos}></NumberFormat>
                    </span>
                </Col>
                <Col className="totalizador" span={12}>
                    <span className="label">Total:</span>
                    <span className="value"><Dinheiro value={dadosPedidosEncontrados.totalPedidos}></Dinheiro></span>
                </Col>
            </Row>
        </>)
    } else {

        return (<>
            <Row className={["toolbox"]} justify="end">
                <Col className="totalizador" >
                    <span className="label">Quantidade:</span>
                    <span className="value">
                        <NumberFormat defaultValue={0} displayType={'text'} value={dadosPedidosEncontrados.quantidadePedidos}></NumberFormat>
                    </span>
                </Col>
                <Col className="totalizador">
                    <span className="label">Total:</span>
                    <span className="value"><Dinheiro value={dadosPedidosEncontrados.totalPedidos}></Dinheiro></span>
                </Col>
            </Row>
            <Row className="toolbox" justify="end">
                <Col>
                    <Button disabled={deveDesabilitarEditar()}>
                        <Link to={baseEditarUrl + selectedRowKeys[0]}>Editar</Link>
                    </Button>
                </Col>
                <Col>
                    <Dropdown
                        overlay={
                            <Menu>
                                <Menu.Item
                                    onClick={() => imprimirHandleClick('pedido')}
                                    disabled={selectedRowKeys.length != 1}
                                >
                                    <FontAwesomeIcon icon={faPrint} /> Pedido Completo
                                </Menu.Item>
                                <Menu.Item
                                    onClick={() => imprimirHandleClick('romaneio')}
                                    disabled={deveDesabilitarRomaneio()}
                                >
                                    <FontAwesomeIcon icon={faFileAlt} /> Romaneio
                                </Menu.Item>
                            </Menu>
                        }
                        disabled={selectedRowKeys.length != 1}
                    >
                        <Button loading={imprimindo} disabled={selectedRowKeys.length != 1} style={{ paddingRight: "5px" }}>
                            <FontAwesomeIcon icon={faPrint} /> Imprimir <FontAwesomeIcon icon={faChevronDown} style={{ marginLeft: "10px", marginRight: 0 }} />
                        </Button>
                    </Dropdown>
                </Col>
                <Col>
                    <Button loading={removendo} onClick={removerHandleClick} disabled={deveDesabilitarRemover()}>Remover</Button>
                </Col>
                <Col>
                    <Button loading={separandoEstoque} onClick={separarEstoqueClickHandle} disabled={deveDesabilitarSepararEstoque()}>Separar Estoque</Button>
                </Col>
                <Col>
                    <Button loading={voltandoEstoque} onClick={voltarEstoqueClickHandle} disabled={deveDesabilitarVoltaEstoque()}>Voltar Estoque</Button>
                </Col>
                <Col>
                    <Button loading={emitindoNFe} onClick={emitirNFeHandle} disabled={deveDesabilitarEmitirNFe()}>Emitir NFe</Button>
                </Col>


            </Row>
        </>)
    }


}

const ListaPedidos = (props) => {

    let { values } = props.values ? props : { values: [] };
    const { buscaPedidos } = props.buscaPedidos ? props : (() => { });
    const { tipoPedido = 'PEDIDO', dadosPedidosEncontrados = {
        totalPedidos: "0",
        quantidadePedidos: "0",
        totalDescontos: "0",
        totalProdutos: "0",
        totalFrete: "0",
        totalServicos: "0"
    } } = props;

    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const { listaStatus } = usePedido();
    const [pedidoImprimir, setPedidoImprimir] = useState({});
    const [mostraImpressao, setMostraImpressao] = useState(false);
    const [statusMap, setStatusMap] = useState([]);
    const [imprimindo, setImprimindo] = useState(false);
    const [tipoImpressao, setTipoImpressao] = useState('pedido');
    const { buscaPedido } = usePedido();



    let columns = [{
        title: 'Numero',
        dataIndex: 'numeroPedido',
        key: "numeroPedido"
    }, {
        title: 'Status',
        dataIndex: 'status',
        key: "status",
        render: value => {
            // let color = 'default';
            // if(value == "EXCLUIDO"){
            //     color = "error";    
            // }
            return (<StatusPedido status={value} statusMap={statusMap}></StatusPedido>)
        }
    }, {
        title: 'Estoque',
        dataIndex: 'estoque',
        key: "estoque",
        render: value => {
            if (value == "SEPARADO") {
                return (<Tag color="green">{value.toLowerCase()}</Tag>)
            } else {
                return <></>
            }
        }

    }, {
        title: 'NFe',
        dataIndex: 'possuiNFe',
        key: "possuiNFe",
        render: value => {
            if (value) {
                return "SIM"
            } else {
                return "-"
            }

        }

    }, {
        title: 'Digitação',
        dataIndex: 'dataAbertura',
        key: "dataAbertura",
        render: value => moment(value).format("DD/MM/YYYY HH:mm:ss")
    }, {
        title: 'Cliente',
        dataIndex: 'cliente',
        key: "nome",
        render: value => value.toUpperCase()
    }, {
        title: 'Vendedor',
        dataIndex: 'vendedor',
        key: "vendedor",
        render: value => value.toUpperCase()
    }, {
        title: 'Produtos',
        dataIndex: 'totalProdutos',
        key: "totalProduto",
        render: value => (<Dinheiro value={value}></Dinheiro>)
    }, {
        title: 'Descontos',
        dataIndex: 'totalDescontos',
        key: "totalDescontos",
        render: value => (<Dinheiro value={value}></Dinheiro>)
    }, {
        title: 'Total',
        dataIndex: 'totalPedido',
        key: "totalPedido",
        render: value => (<Dinheiro value={value}></Dinheiro>)
    }];



    useEffect(() => {
        carregaStatus();
    }, []);

    const carregaStatus = async () => {
        const statusList = await listaStatus();
        const newStatusMap = {};
        statusList.forEach(status => {
            newStatusMap[status.slug] = status;
        });

        setStatusMap(newStatusMap);
    }


    const onChangeSelection = (keysSelected) => {
        console.log('selectedRowKeys changed: ', keysSelected);
        setSelectedRowKeys(keysSelected);
    }


    // const definePedidoImprimir = async (rowKey) => {
    //     const pedido = await buscaPedido(rowKey)
    //     setPedidoImprimir({ ...pedido });
    //     // return pedido;
    // }

    const definePedidoImprimir = async (rowKey) => {
        const pedido = await buscaPedido(rowKey)
        setPedidoImprimir({ ...pedido });
        return pedido;
    }


    useEffect(() => {
        setPedidoImprimir({ onReady: () => { } });
        // if(selectedRowKeys && selectedRowKeys.length == 1){
        //     definePedidoImprimir(selectedRowKeys[0]);
        //     return;
        // }

    }, [selectedRowKeys]);




    if (tipoPedido == "ORDEM_SERVICO") {
        columns.splice(8, 0, {
            title: 'Serviços',
            dataIndex: 'totalServicos',
            key: "totalServicos",
            render: value => (<Dinheiro value={value}></Dinheiro>)
        })
    }

    return (
        <div className="lista-wrapper">


            <Toolbar values={values}
                onExcluir={() => { setSelectedRowKeys([]) }}
                selectedRowKeys={selectedRowKeys}
                dadosPedidosEncontrados={dadosPedidosEncontrados}
                tipoPedido={tipoPedido}
                buscaPedidos={buscaPedidos}
                // pedidoImprimir={pedidoImprimir}
                definePedidoImprimir={definePedidoImprimir.bind(this)}
                // setPedidoImprimir={setPedidoImprimir}
                // setMostraImpressao={setMostraImpressao}
                setImprimindo={setImprimindo}
                imprimindo={imprimindo}
                setTipoImpressao={setTipoImpressao}
            ></Toolbar>
            <Row className="rowTable">

                <Col span={24}>
                    <Table size="small"
                        scroll={{
                            x: true
                        }}
                        columns={columns}
                        dataSource={values}
                        rowSelection={{
                            selectedRowKeys: selectedRowKeys,
                            onChange: onChangeSelection
                        }}

                        rowClassName={(record, index) => {
                            if (record.status == "EXCLUIDO") {
                                return "excluido"
                            }
                            return "";
                        }}

                        onRow={(record, rowIndex) => {
                            return {

                                onClick: event => {

                                    // const novoSelectedRowKeys = [Array.from(selectedRowKeys)];

                                    // const indiceRecord = novoSelectedRowKeys.indexOf(record.uuid);
                                    // console.log("record", indiceRecord);
                                    // if(indiceRecord < 0){
                                    //     novoSelectedRowKeys.push(record.uuid);                                    
                                    // } else {
                                    //     novoSelectedRowKeys.splice(indiceRecord , 1);
                                    // }

                                    const novoSelectedRowKeys = [record.id];
                                    setSelectedRowKeys(novoSelectedRowKeys);
                                }, // click row
                            }
                        }}

                    ></Table>

                </Col>
            </Row>

            {tipoImpressao === 'romaneio' ?
                <ImpressaoRomaneio pedido={pedidoImprimir}></ImpressaoRomaneio> :
                <ImpressaoPedido pedido={pedidoImprimir} ></ImpressaoPedido>
            }

        </div>
    );
}

export { ListaPedidos };